/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Icd10Code
 */
export interface Icd10Code {
    /**
     * 
     * @type {string}
     * @memberof Icd10Code
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof Icd10Code
     */
    code: string;
    /**
     * 
     * @type {string}
     * @memberof Icd10Code
     */
    short_description: string;
}

/**
 * Check if a given object implements the Icd10Code interface.
 */
export function instanceOfIcd10Code(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "code" in value;
    isInstance = isInstance && "short_description" in value;

    return isInstance;
}

export function Icd10CodeFromJSON(json: any): Icd10Code {
    return Icd10CodeFromJSONTyped(json, false);
}

export function Icd10CodeFromJSONTyped(json: any, ignoreDiscriminator: boolean): Icd10Code {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'code': json['code'],
        'short_description': json['short_description'],
    };
}

export function Icd10CodeToJSON(value?: Icd10Code | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'code': value.code,
        'short_description': value.short_description,
    };
}

